
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/style/elements",
      function () {
        return require("private-next-pages/style/elements.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/style/elements"])
      });
    }
  